import Vue from 'vue'

export default class BackendApi {

    constructor(configApp) {
        this.configApp = configApp
        this.backendUrl = this.configApp.backendUrl + "api/"
        this.tokenAccess = BackendApi.getTokenAccess();
    }
    
    autoLogin(name, cb) {
        //let self = this;
        //console.log("login : ", username,password);
        //console.log(Vue.axios);
        //console.log(this.baseUrl + "login");
        
        Vue.axios.post(this.backendUrl + "auth/auto-login", JSON.stringify({
            name: name,
            accountId: 0,
            tokenAccess: this.tokenAccess
        }))
        .then((response) => {
            //console.log(this.baseUrl + "login");
            console.log("Response -> BackendApi::autoLogin", response);

            let res = (response.data) ? response.data: null;
            //console.log(response.data)
            if(res && res.success) {         
                let data = res.data       
                localStorage.setItem("tokenAccess",data.tokenAccess);
                cb({
                    userId: data.userId,
                    name: data.name,
                    isLogged: true,
                    tokenAccess: data.tokenAccess,                    
                    accountId: data.accountId,
                    queue: data.queue,
                    username: data.username
                });
            }
            else {
                cb({
                  userId: 0,
                  name: "",
                  isLogged: false,
                  tokenAccess: "",
                  accountId: 0,
                  queue: "",
                  username: ""
                });
            }
        })
        .catch(function (error) {
            console.error('ERROR -> BackendApi::autoLogin',error);
            cb({
                userId: 0,
                name: "",
                isLogged: false,
                tokenAccess: "",  
                accountId: 0,
                queue: "",
                username: ""
            });
        })
  }
    saveip(ip) {
      Vue.axios.post(
        this.backendUrl + "auth/saveip",
        JSON.stringify({
          ip: ip
        }))
        .then((response) => {
          console.log("Response -> BackendApi::Login", response);
        });
    }
    login(username, password,sessionId,accountId, cb) {
        Vue.axios.post(
          this.backendUrl + "auth/login",
          JSON.stringify({
            username: username,
            password: password,
            sessionId: sessionId,
            accountId: accountId,
          }))
          .then((response) => {
              //console.log(this.baseUrl + "login");
              console.log("Response -> BackendApi::Login", response);

              let res = response.data ? response.data : null;
              //console.log(response.data);
              if (res && res.success) {
                  let data = res.data;
                  localStorage.setItem("tokenAccess", data.tokenAccess);
                  cb({
                      userId: data.userId,
                      name: data.name,
                      isLogged: true,
                      tokenAccess: data.tokenAccess,
                      accountId: data.accountId,
                      queue: data.queue,
                      username: data.username,
                      status: data.status,
                      admin: data.admin
                  });
              } else { 
                  cb({
                    userId: 0,
                    name: "",
                    isLogged: false,
                    tokenAccess: "",
                    accountId: 0,
                    queue: "",
                    username: "",
                    status: null,
                    admin: null,
                  });
              }
            })
            .catch(function(error) {
                 console.error("ERROR -> BackendApi::autoLogin", error);
                 cb({
                   userId: 0,
                   name: "",
                   isLogged: false,
                   tokenAccess: "",
                   accountId: 0,
                   queue: "",
                   username: "",
                   status: null,
                   admin: null,
                 });
            })
        
    }
    updateAccountChat(chatId,accountId,cb){
      Vue.axios.post(
        this.backendUrl + "auth/update-account-chat",
        JSON.stringify({
          chatId: chatId,
          accountId: accountId,
        }))
        .then((response) => {
            console.log("Response -> BackendApi::Login", response);

            let res = response.data ? response.data : null;
            //console.log(response.data);
            if (res && res.success) {
                cb({
                    success: true
                })
            } else {
                cb({
                    success: false
                })
            }
        })
        .catch(function (error) {
            console.log("ERROR " + error)
            cb({
                success: false
            })
            
        })
    }

  static getTokenAccess() {
    return localStorage.getItem("tokenAccess","");
  }

    verificaAuth(token_access, username, cb) {
        Vue.axios.post(
            this.backendUrl + "user/check-auth",
            JSON.stringify({
                tokenAccess: token_access,
                username: username,
            }))
            .then((response) => {
                console.log("Response -> BackendApi::Login", response);

                let res = response.data ? response.data : null;
                //console.log(response.data);
                if (res && res.success) {
                    cb({
                        success: true
                    })
                } else {
                    cb({
                        success: false
                    })
                }
            })
            .catch(function (error) {
                console.log("ERROR " + error)
                cb({
                    success: false
                })
                
            })
  }

  logout(user_id,operatore_id = "", cb) {
        Vue.axios
          .post(
            this.backendUrl + "user/logout",
            JSON.stringify({
              userId: user_id,
              operatoreId: operatore_id
            })
          )
          .then((response) => {
            //console.log(this.baseUrl + "login");
            console.log("Response -> BackendApi::Logout", response);

            let res = response.data ? response.data : null;
            //console.log(response.data);
            if (res && res.success) {
              cb({
                success:true
              });
            } else {
              cb({
                success: false,
              });
            }
          })
          .catch(function(error) {
            console.error("ERROR -> BackendApi::Logout", error);
            cb({
              success: false,
            });
            
          });
        
    }
  
  changeStatus(user_id, cb) {
        Vue.axios
          .post(
            this.backendUrl + "user/change-status",
            JSON.stringify({
              userId: user_id,
            })
          )
          .then((response) => {
            //console.log(this.baseUrl + "login");
            console.log("Response -> BackendApi::ChangeStatus", response);

            let res = response.data ? response.data : null;
            //console.log(response.data);
            if (res && res.success) {
              let data = res.data;
              cb({
                userId: data.userId,
                name: data.name,
                isLogged: true,
                tokenAccess: data.tokenAccess,
                accountId: data.accountId,
                queue: data.queue,
                username: data.username,
                status: data.status,
                admin: data.admin,
              });
            } 
          })
          .catch(function(error) {
            console.error("ERROR -> BackendApi::ChangeStatus", error);
            
          });
        
    }
  
    operatoreChatList(staff_id, cb) { 
       Vue.axios
         .post(
           this.backendUrl + "chat/chat-list",
           JSON.stringify({
             staff_id: staff_id
           })
         )
         .then((response) => {
           //console.log(this.baseUrl + "login");
           console.log("Response -> BackendApi::ChatList", response);

           let res = response.data ? response.data : null;
           //console.log(response.data);
           if (res && res.success) {
             let data = res.data;
             cb({
               chat_user_assigned: data.chat_user_assigned,
               chat_other_assigned: data.chat_other_assigned,
               chat_not_assigned: data.chat_not_assigned,
               chat_archived: data.chat_archived,
             });
           } else {
             cb({
               chat_user_assigned: null,
               chat_other_assigned: null,
               chat_not_assigned: null,
               chat_archived: null,
             });
           }
         })
         .catch(function(error) {
           console.error("ERROR -> BackendApi::autoLogin", error);
           cb({
             chat_user_assigned: null,
             chat_other_assigned: null,
             chat_not_assigned: null,
             chat_archived: null,
           });
         });
  }
  
  prendiInCarico(chat_id, staff_id, cb) {
    Vue.axios
      .post(
        this.backendUrl + "chat/prendi-in-carico",
        JSON.stringify({
          chat_id: chat_id,
          staff_id: staff_id,
        })
      )
      .then((response) => {
        //console.log(this.baseUrl + "login");
        console.log("Response -> BackendApi::PrendiInCarico", response);

        let res = response.data ? response.data : null;
        //console.log(response.data);
        if (res && res.success) {
          let data = res.data;
          cb({
            chat_user_assigned: data.chat_user_assigned,
            chat_other_assigned: data.chat_other_assigned,
            chat_not_assigned: data.chat_not_assigned,
            chat_archived: data.chat_archived,
            success: true,
          });
        } else {
          cb({
            chat_user_assigned: null,
            chat_other_assigned: null,
            chat_not_assigned: null,
            chat_archived: null,
            success: false,
          });
        }
      })
      .catch(function(error) {
        console.error("ERROR -> BackendApi::PrendiInCarico", error);
        cb({
          chat_user_assigned: null,
          chat_other_assigned: null,
          chat_not_assigned: null,
          chat_archived: null,
          success: false,
        });
      });
  }


  rilasciaChat(chat_id, staff_id, cb) {
    Vue.axios
      .post(
        this.backendUrl + "chat/rilascia-chat",
        JSON.stringify({
          chat_id: chat_id,
          staff_id: staff_id,
        })
      )
      .then((response) => {
        //console.log(this.baseUrl + "login");
        console.log("Response -> BackendApi::RilasciaChat", response);

        let res = response.data ? response.data : null;
        //console.log(response.data);
        if (res && res.success) {
          let data = res.data;
          cb({
            chat_user_assigned: data.chat_user_assigned,
            chat_other_assigned: data.chat_other_assigned,
            chat_not_assigned: data.chat_not_assigned,
            chat_archived: data.chat_archived,
            success: true,
          });
        } else {
          cb({
            chat_user_assigned: null,
            chat_other_assigned: null,
            chat_not_assigned: null,
            chat_archived: null,
            success: false,
          });
        }
      })
      .catch(function(error) {
        console.error("ERROR -> BackendApi::RilasciaChat", error);
        cb({
          chat_user_assigned: null,
          chat_other_assigned: null,
          chat_not_assigned: null,
          chat_archived: null,
          success: false,
        });
      });
  }

  chiudiChat(chat_id, staff_id, cb) {
    Vue.axios
      .post(
        this.backendUrl + "chat/chiudi-chat",
        JSON.stringify({
          chat_id: chat_id,
          staff_id: staff_id,
        })
      )
      .then((response) => {
        //console.log(this.baseUrl + "login");
        console.log("Response -> BackendApi::ChiudiChat", response);

        let res = response.data ? response.data : null;
        //console.log(response.data);
        if (res && res.success) {
          let data = res.data;
          cb({
            chat_user_assigned: data.chat_user_assigned,
            chat_other_assigned: data.chat_other_assigned,
            chat_not_assigned: data.chat_not_assigned,
            chat_archived: data.chat_archived,
            success: true,
          });
        } else {
          cb({
            chat_user_assigned: null,
            chat_other_assigned: null,
            chat_not_assigned: null,
            chat_archived: null,
            success: false,
          });
        }
      })
      .catch(function(error) {
        console.error("ERROR -> BackendApi::ChiudiChat", error);
        cb({
          chat_user_assigned: null,
          chat_other_assigned: null,
          chat_not_assigned: null,
          chat_archived: null,
          success: false,
        });
      });
  }

  search(tipo_ricerca , txt, staff_id, data_search, cb)
  {
    Vue.axios.post(
      this.backendUrl + "chat/chat-list",
      JSON.stringify({
        tipo_ricerca: tipo_ricerca,
        txt: txt,
        search: 1,
        staff_id: staff_id,
        data: data_search
      })
    ).then((response) => {
      //console.log(this.baseUrl + "login");
      console.log("Response -> BackendApi::Search", response);

      let res = response.data ? response.data : null;
      //console.log(response.data);
      if (res && res.success) {
        let data = res.data;
        
        cb({
          chat_user_assigned: data.chat_user_assigned,
          chat_other_assigned: data.chat_other_assigned,
          chat_not_assigned: data.chat_not_assigned,
          chat_archived: data.chat_archived,
          success: true,
        });
      } else {
        console.log("Empty esponse -> BackendApi::Search", response);
        cb({
          chat_user_assigned: null,
          chat_other_assigned: null,
          chat_not_assigned: null,
          chat_archived: null,
          success: false,
        });
      }
    })
      .catch(function (error) {
        console.error("ERROR -> BackendApi::ChiudiChat", error);
        cb({
          chat_user_assigned: null,
          chat_other_assigned: null,
          chat_not_assigned: null,
          chat_archived: null,
          success: false,
        });
      });    
  }

  getClientChat(token_access, cb) { 
    Vue.axios
      .post(
        this.backendUrl + "chat/get-client-chat",
        JSON.stringify({
          token_access: token_access,
        })
      )
      .then((response) => {
        console.log("Response -> BackendApi::getClientChat", response);
        let res = response.data ? response.data : null;
        if (res && res.success) { 
          let data = res.data;
          cb({
            chat_id: data["id"],
            user_id: data["user_id"],
            status: data["status"],
            queue: data["queue"],
            channel: data["channel"],
            staff_id: data["staff_id"],
            counter_notify: data["counter_notify"],
            success: true,
          });
        } else {
          console.log("Empty esponse -> BackendApi::listMessage", response);
          cb({
            chat_id: null,
            user_id: null,
            status: null,
            queue: null,
            channel: null,
            staff_id: null,
            counter_notify:0,
            success: false,
          });
        }
      })
      .catch(function (error) {
        console.error("ERROR -> BackendApi::getClientChat", error);
        cb({
          chat_id: null,
          user_id: null,
          status: null,
          queue: null,
          channel: null,
          staff_id: null,
          counter_notify: 0,
          success: false,
        });
      }); 
  }

  listMessage(chat_id, staff_id,limit = 10, cb) {
    Vue.axios
      .post(
        this.backendUrl + "chat/get-list-message",
        JSON.stringify({
          chat_id: chat_id,
          staff_id: staff_id,
          limit: limit
        })
      )
      .then((response) => {
        console.log("Response -> BackendApi::listMessage", response);

        let res = response.data ? response.data : null;
        if (res && res.success) {
          let data = res.data;
          cb({
            chat_list_message: data["list_message"],
            count: data["count"],
            count_all: data["count_all"],
            suggerimenti: data["suggerimenti"],
            success: true,
          });
        } else {
          console.log("Empty esponse -> BackendApi::listMessage", response);
          cb({
            chat_list_message: null,
            success: false,
          });
        }
      })
      .catch(function(error) {
        console.error("ERROR -> BackendApi::listMessage", error);
        cb({
          chat_list_message: null,
          success: false,
        });
      }); 
  }

  saveMessageAttach(formData,cb)
  {
     Vue.axios
      .post(
        this.backendUrl + "chat/save-message-attach",
        formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        }
     ).then((response) => {
       console.log("RESPONSE API ATTACH ", response)
        let res = response.data ? response.data : null;
        if (res && res.success) {
          let data = res.data;
          cb({
            message_id: data["messageId"],
            success: true
          })
        }
      })
      .catch(function(error){
        console.error("ERROR -> BackendApi::listMessage", error);
        cb({
          message_id: "",
          success: false
        });
      });
  }

  infoChat(chat_id, cb)
  {
    Vue.axios
      .post(
        this.backendUrl + "chat/info-chat",
        JSON.stringify({
          chat_id: chat_id,
        })
    ).then((response) => { 
        let res = response.data ? response.data : null;
        if (res && res.success) {
          let data = res.data;
          cb({
            success:true,
            account: data["account"],
            link_account: data["link_account"],
            data_scadenza: data["data_scadenza"],
            channel: data["channel"],
            sito_web: data["sito_web"],
            link_sito_web: data["link_sito_web"],
          })
        }
    })
    .catch(function(error){
        console.error("ERROR -> BackendApi::infoChat", error);
        cb({
          success: false,
          account: null,
          link_account: null,
          data_scadenza: null,
          channel: null,
          sito_web: null,
          link_sito_web: null,
        });
      });
  }

  generaLead(formData, cb)
  {
    Vue.axios
      .post(
        this.backendUrl + "chat/genera-lead",
        formData,
        
      ).then((response) => {
        console.log("RESPONSE API ATTACH ", response)
        let res = response.data ? response.data : null;
        if (res && res.success) {
          cb({
            success: true
          })
        }
      })
      .catch(function(error){
          console.error("ERROR -> BackendApi::infoChat", error);
          cb({
            success: false,

          });
        });
  }

  trovaCivici(formData,cb)
  {
    Vue.axios
    .post(
      this.backendUrl + "chat/trova-civici",
      formData,
      
    ).then((response) => {
      console.log("RESPONSE API ATTACH ", response)
      let res = response.data ? response.data : null;
      let dataR = res.data;
      if (res && res.success) {
        cb({
          success: true,
          data: []
        })
      }
      else
      {
        cb({
          success: false,
          data: dataR
        })
      }
    })
    .catch(function(error){
        console.error("ERROR -> BackendApi::infoChat", error);
        cb({
          success: false,

        });
      });
  }

  listaOperatori(cb)
  {
     Vue.axios
      .post(
        this.backendUrl + "chat/lista-operatori",
        
      ).then((response) => {
        console.log("RESPONSE API OPERATORI ", response)
        let res = response.data ? response.data : null;
        if (res && res.success) {
          cb({
            lista: res,
            success: true
          })
        }
      })
      .catch(function(error){
          console.error("ERROR -> BackendApi:ListOperatori", error);
          cb({
            lista: null,
            success: false
          });
        });
  }


  aliveOperator(userId)
  {
     Vue.axios
      .post(
        this.backendUrl + "chat/alive-operator",
        JSON.stringify({
          userId: userId,
        })
      ).then((response) => {
        console.log("RESPONSE aliveOperator  ", response)
      })
      .catch(function(error){
        console.error("ERROR -> BackendApi:aliveOperator", error);
      });
  }

  getProvinceComuni(cb)
  {
    Vue.axios
    .post(
      this.backendUrl + "chat/get-comuni",
      
    ).then((response) => {
      let res = response.data ? response.data : null;
      if (res && res.success) {
       
        cb({
          result: res,
          success: true
        })
      }
    })
    .catch(function(error){
        console.error("ERROR -> BackendApi:getProvinceComuni", error);
        cb({
          result: null,
          success: true
        });
      });
  }
  
}